module.exports = __webpack_public_path__ + "img/bbc_radio_scotland.69c79a25.png";